import React from "react";
import { useAppSelector } from "src/app-redux/hooks";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { currentSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import Notifications from "./Notifications";
import { useStyles } from "./style";

export interface IProps {
  isDrawerOpen: boolean;
  handleCloseDrawer: any;
}

export default function NotificationDrawer(props: IProps) {
  const classes = useStyles();
  const selectedVehicleId = useAppSelector(currentSelectedVehicleId);

  React.useEffect(() => {
    getVehicleDetailsByIdAction(selectedVehicleId);
  }, []);
  return (
    <>
      <CommonDrawer
        heading={"Notifications"}
        isOpen={props.isDrawerOpen}
        closeDrawer={() => {
          props.handleCloseDrawer();
        }}
        drawerWidth={450}
        border={false}
      >
        <div className={classes.mainDrawer}>
          <Notifications />
        </div>
      </CommonDrawer>
    </>
  );
}
